const defaultMargin = 8;

export const COLORS = {
  TMG: '#173659',
  TIC: '#2186EB',
};

const Palettes = {
  TMG: {
    palette: {
      primary: COLORS.TMG,
      nav: '#051229',
      cta: '#FBAF1A',
    },
  },
  TIC: {
    palette: {
      primary: COLORS.TIC,
      nav: '#002159',
      cta: '#FF9703',
    },
  },
};

const defaultSettings = {
  breakpoints: {
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
  },
  spacing: {
    default: defaultMargin,
    margin: (multiplier) => defaultMargin * multiplier,
  },
};

export default (brand) => {
  const palette = Palettes[brand];
  return {
    ...palette,
    ...defaultSettings,
  };
};
